export default __webpack_public_path__ + "static/media/3.bc2f0f44.mp3";